"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _utils = require("../lib/utils");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeatureFlagRenderer = function (_Component) {
  _inherits(FeatureFlagRenderer, _Component);

  function FeatureFlagRenderer(props) {
    _classCallCheck(this, FeatureFlagRenderer);

    var _this = _possibleConstructorReturn(this, (FeatureFlagRenderer.__proto__ || Object.getPrototypeOf(FeatureFlagRenderer)).call(this, props));

    var _this$props = _this.props,
        flagKey = _this$props.flagKey,
        clientOptions = _this$props.clientOptions;

    var bootstrap = clientOptions && clientOptions.bootstrap;

    _this.state = {
      checkFeatureFlagComplete: false,
      flagValue: bootstrap && (typeof bootstrap === "undefined" ? "undefined" : _typeof(bootstrap)) === "object" && bootstrap.hasOwnProperty(flagKey) ? bootstrap[flagKey] : false
    };
    return _this;
  }

  _createClass(FeatureFlagRenderer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          clientId = _props.clientId,
          user = _props.user,
          clientOptions = _props.clientOptions;


      this._isMounted = true;

      if (clientOptions && clientOptions.disableClient) {
        return;
      }

      // Only initialize the launch darkly js-client when in browser,
      // can not be initialized on SSR due to dependency on XMLHttpRequest.
      var ldClient = (0, _utils.ldClientWrapper)(clientId, user, clientOptions);

      this.checkFeatureFlag(ldClient);
      this.listenFlagChangeEvent(ldClient);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderLogic();
    }
  }, {
    key: "renderLogic",
    value: function renderLogic() {
      var _state = this.state,
          flagValue = _state.flagValue,
          checkFeatureFlagComplete = _state.checkFeatureFlagComplete;
      var _props2 = this.props,
          renderFeatureCallback = _props2.renderFeatureCallback,
          renderDefaultCallback = _props2.renderDefaultCallback,
          initialRenderCallback = _props2.initialRenderCallback;


      if (flagValue) {
        return renderFeatureCallback(flagValue);
      } else if (checkFeatureFlagComplete && renderDefaultCallback) {
        return renderDefaultCallback();
      }

      if (initialRenderCallback) {
        return initialRenderCallback();
      }

      return null;
    }
  }, {
    key: "checkFeatureFlag",
    value: function checkFeatureFlag(ldClient) {
      var _this2 = this;

      var flagKey = this.props.flagKey;


      ldClient.onReady(function () {
        var flagValue = ldClient.variation(flagKey, false);
        _this2.setStateFlagValue(flagValue);
      });
    }
  }, {
    key: "listenFlagChangeEvent",
    value: function listenFlagChangeEvent(ldClient) {
      var _this3 = this;

      var flagKey = this.props.flagKey;


      ldClient.on("change:" + flagKey, function (value) {
        _this3.setStateFlagValue(value);
      });
    }
  }, {
    key: "setStateFlagValue",
    value: function setStateFlagValue(flagValue) {
      var flagKey = this.props.flagKey;

      var typeFlagValue = typeof flagValue === "undefined" ? "undefined" : _typeof(flagValue);
      var defaultState = { checkFeatureFlagComplete: true };
      var override = (0, _utils.ldOverrideFlag)(flagKey, typeFlagValue);

      // Due to this function being called within a callback, we can run into issues
      // where we try to set the state for an unmounted component. Since `isMounted()` is deprecated
      // as part of a React class, we can create our own way to manage it within the protoype.
      // See https://github.com/facebook/react/issues/5465#issuecomment-157888325 for more info
      if (!this._isMounted) {
        return;
      }

      if (typeof override !== "undefined") {
        // Override is set for this flag key, use override instead
        this.setState(_extends({ flagValue: override }, defaultState));
      } else if (flagValue) {
        this.setState(_extends({ flagValue: flagValue }, defaultState));
      } else {
        this.setState(_extends({ flagValue: false }, defaultState));
      }
    }
  }]);

  return FeatureFlagRenderer;
}(_react.Component);

exports.default = FeatureFlagRenderer;


//////////////////
// WEBPACK FOOTER
// ./~/react-launch-darkly/build/components/FeatureFlagRenderer.js
// module id = 1146
// module chunks = 0